"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Header = _interopRequireDefault(require("./Header.style"));

var Header = function Header(_ref) {
  var id = _ref.id,
      label = _ref.label,
      onIconClick = _ref.onIconClick,
      icon = _ref.icon;
  return _react.default.createElement(_Header.default, null, (0, _isFunction.default)(label) ? label() : label, icon && _react.default.createElement("button", {
    onClick: function onClick() {
      return onIconClick(id);
    }
  }, _react.default.createElement(_Icon.default, {
    type: icon
  })));
};

Header.propTypes = {
  id: _propTypes.default.string.isRequired,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func.isRequired]).isRequired,
  onIconClick: _propTypes.default.func.isRequired,
  icon: _propTypes.default.string.isRequired
};
var _default = Header;
exports.default = _default;